import curry from 'lodash/fp/curry'
import every from 'lodash/fp/every'
import identity from 'lodash/fp/identity'
import map from 'lodash/fp/map'
import negate from 'lodash/fp/negate'
import pipe from 'lodash/fp/pipe'
import prop from 'lodash/fp/prop'
import zipObject from 'lodash/fp/zipObject'
import fromPairs from 'lodash/fromPairs'
import toPairs from 'lodash/toPairs'
import * as RasaInput from '../../components/rasa-input'
import * as Utils from '../../utils'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Reducer from './reducer'
import * as Types from './types'

export type ActionConstants = string[]
export type CreateFormConstants = (prefix: Constants.FormPrefix) => ActionConstants
export const createFormConstants: CreateFormConstants =
  Utils.createConstants(Constants.verbs, Constants.NOUN + '/')

export type CreateConstantsMap = (prefix: Constants.FormPrefix) => Actions.ConstantsMap
export const createConstantsMap: CreateConstantsMap = pipe(
  createFormConstants,
  zipObject(Constants.verbs),
)

export const selectFormFields = prop('form.fields')

type IsFieldsValid = (fieldValidations: RasaInput.Validation[]) => boolean
export const isFieldsValid: IsFieldsValid = pipe(
  map(RasaInput.selectInvalid),
  map(negate(identity)),
  every(identity),
)
export const validateFormFields = curry<Types.FormValidators, Types.Fields<{}>, RasaInput.Validation[]>(
  (validators, fields) =>
    toPairs(validators).map(([fieldName, validator]) => validator(fields[fieldName])))

export const isValid: Types.Validator = pipe(
  map(RasaInput.selectInvalid),
  map(negate(identity)),
  every(identity),
)

export const modifiedFields = <T>(state: Reducer.State<T>): Types.Fields<T> =>
  fromPairs(toPairs(state.fields).filter(([key, value]) => state.initialValues[key] !== value))
export const join = Utils.join



// WEBPACK FOOTER //
// ./src/components/form/utils.ts